import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-011006c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-control" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Das Passwort muss mindestens 8 Stellen besitzen und darf nur aus Buchstaben und Zahlen bestehen. Zudem müssen ein Großbuchstabe, ein Kleinbuchstabe und eine Zahl enthalten sein. ")
], -1))
const _hoisted_7 = { class: "captcha" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bitte nachfolgendes Captcha lösen:", -1))
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Hinweise zur Datenverwendung", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Ihre Daten werden ohne Ihre ausrückliche Einwilligung nur zum Zweck der Vertragsabwicklung und Kundenbetreuung verwendet. Weiterführende Informationen zum Datenschutz entnehmen Sie bitte unseren "),
  /*#__PURE__*/_createElementVNode("a", { href: "" }, "ausführlichen Datenschutzhinweisen"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.passwordConfirm.isValid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Passwort überprüfen"))
        : (!_ctx.captchaValid.isValid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Captcha überprüfen"))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_base_label, { title: 'Passwort*' }),
      _createVNode(_component_base_label, {
        margin: '315px',
        title: 'Passwort wiederholen*'
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_base_input, {
        type: 'password',
        modelValue: _ctx.password.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password.value) = $event)),
        valid: _ctx.password.isValid,
        onBlur: _ctx.validatePassword,
        width: '300px'
      }, null, 8, ["modelValue", "valid", "onBlur"]),
      _createVNode(_component_base_input, {
        type: 'password',
        modelValue: _ctx.passwordConfirm.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordConfirm.value) = $event)),
        valid: _ctx.passwordConfirm.isValid,
        onBlur: _ctx.validatePasswordConfirm,
        width: '300px'
      }, null, 8, ["modelValue", "valid", "onBlur"])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", null, [
        _createVNode(_component_vue_recaptcha, {
          sitekey: _ctx.siteKey,
          onVerify: _ctx.onVerify,
          onExpired: _ctx.onExpired
        }, null, 8, ["sitekey", "onVerify", "onExpired"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_base_button, {
        title: 'Zurück',
        onClick: _ctx.backToContact
      }, null, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        title: 'Senden',
        onClick: _ctx.submitResult
      }, null, 8, ["onClick"])
    ]),
    _hoisted_10,
    _hoisted_11
  ], 64))
}